'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.init = undefined;

var _jsCookie = require('js-cookie');

var _jsCookie2 = _interopRequireDefault(_jsCookie);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var promoBar = function promoBar() {
  var bodyTag = document.querySelector('[data-site-body]');
  var cookieName = 'promobar_closed';
  var cookieState = _jsCookie2.default.get(cookieName);
  var closeButton = document.querySelector('[data-promo-bar-close]');
  var promoBar = document.querySelector('[data-promo-bar]');

  // Promo Bar
  if (promoBar !== null && cookieState !== 'true') {
    bodyTag.classList.add('promo-bar-active');
  }

  // Close Promo Bar
  closeButton.addEventListener('click', function () {
    _jsCookie2.default.set(cookieName, 'true', { expires: 7 });
    bodyTag.classList.remove('promo-bar-active');
  });
};

var init = exports.init = function init() {
  promoBar();
};